import { TTintService } from '../types/service-cookie.type';

type TProps = {
  services: TTintService[];
  newTintService: {
    serviceIdForTint: string;
    hex: string;
    parentLineId: string;
    color: string;
  };
  newQuantity: number;
};

export const getServicesWithNewTintService = ({ services, newTintService, newQuantity }: TProps) => {
  const { serviceIdForTint, hex, parentLineId, color } = newTintService;

  return [
    ...services,
    {
      id: parseInt(serviceIdForTint, 10),
      quantity: newQuantity,
      parentLineId,
      parameters: {
        color,
      },
      hex,
    },
  ];
};
